/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminClassDetailDTO,
  AdminClassEnrollmentsListItemDTO,
  AdminClassEnrollmentsListItemDTOQueryResultDTO,
  AdminClassGetAdminClassEnrollmentsParams,
  AdminClassGetAdminClassesForOrganizationListParams,
  AdminClassGetAdminClassesForOrganizationParams,
  AdminClassListItemDTOQueryResultDTO,
  BulkCopyClassesDTO,
  BulkCopyClassesResultDTO,
  FilterModelDTO,
  QueryColumnConfigDTO,
  UpsertAdminClassDTO,
  UpsertAdminClassEnrollmentDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminClassGetAdminClassDetail = (
    organizationId: number,
    classId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/${classId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminClassGetAdminClassDetailQueryKey = (organizationId: number,
    classId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClass/${classId}`] as const;
    }

    
export const getAdminClassGetAdminClassDetailQueryOptions = <TData = Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassGetAdminClassDetailQueryKey(organizationId,classId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>> = ({ signal }) => adminClassGetAdminClassDetail(organizationId,classId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && classId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassGetAdminClassDetailQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>>
export type AdminClassGetAdminClassDetailQueryError = ErrorType<unknown>


export function useAdminClassGetAdminClassDetail<TData = Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassDetail<TData = Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassDetail<TData = Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassGetAdminClassDetail<TData = Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassGetAdminClassDetailQueryOptions(organizationId,classId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassGetAdminClassesForOrganization = (
    organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminClassGetAdminClassesForOrganizationQueryKey = (organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClass`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminClassGetAdminClassesForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassGetAdminClassesForOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>> = ({ signal }) => adminClassGetAdminClassesForOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassGetAdminClassesForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>>
export type AdminClassGetAdminClassesForOrganizationQueryError = ErrorType<unknown>


export function useAdminClassGetAdminClassesForOrganization<TData = Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminClassGetAdminClassesForOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassesForOrganization<TData = Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassesForOrganization<TData = Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassGetAdminClassesForOrganization<TData = Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminClassGetAdminClassesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassGetAdminClassesForOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassCreateClassForOrganization = (
    organizationId: number,
    upsertAdminClassDTO: UpsertAdminClassDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassDTO, signal
    },
      );
    }
  


export const getAdminClassCreateClassForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>, TError,{organizationId: number;data: UpsertAdminClassDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>, TError,{organizationId: number;data: UpsertAdminClassDTO}, TContext> => {
    
const mutationKey = ['adminClassCreateClassForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>, {organizationId: number;data: UpsertAdminClassDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminClassCreateClassForOrganization(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassCreateClassForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>>
    export type AdminClassCreateClassForOrganizationMutationBody = UpsertAdminClassDTO
    export type AdminClassCreateClassForOrganizationMutationError = ErrorType<unknown>

    export const useAdminClassCreateClassForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>, TError,{organizationId: number;data: UpsertAdminClassDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassCreateClassForOrganization>>,
        TError,
        {organizationId: number;data: UpsertAdminClassDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassCreateClassForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassGetAdminClassesForOrganizationList = (
    organizationId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminClassGetAdminClassesForOrganizationListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminClassGetAdminClassesForOrganizationListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminClassGetAdminClassesForOrganizationListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminClassGetAdminClassesForOrganizationListParams}, TContext> => {
    
const mutationKey = ['adminClassGetAdminClassesForOrganizationList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>, {organizationId: number;data: FilterModelDTO[];params?: AdminClassGetAdminClassesForOrganizationListParams}> = (props) => {
          const {organizationId,data,params} = props ?? {};

          return  adminClassGetAdminClassesForOrganizationList(organizationId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassGetAdminClassesForOrganizationListMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>>
    export type AdminClassGetAdminClassesForOrganizationListMutationBody = FilterModelDTO[]
    export type AdminClassGetAdminClassesForOrganizationListMutationError = ErrorType<unknown>

    export const useAdminClassGetAdminClassesForOrganizationList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminClassGetAdminClassesForOrganizationListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassGetAdminClassesForOrganizationList>>,
        TError,
        {organizationId: number;data: FilterModelDTO[];params?: AdminClassGetAdminClassesForOrganizationListParams},
        TContext
      > => {

      const mutationOptions = getAdminClassGetAdminClassesForOrganizationListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassGetAdminClassFilterConfig = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getAdminClassGetAdminClassFilterConfigQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClass/filter-config`] as const;
    }

    
export const getAdminClassGetAdminClassFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassGetAdminClassFilterConfigQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>> = ({ signal }) => adminClassGetAdminClassFilterConfig(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassGetAdminClassFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>>
export type AdminClassGetAdminClassFilterConfigQueryError = ErrorType<unknown>


export function useAdminClassGetAdminClassFilterConfig<TData = Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassFilterConfig<TData = Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassFilterConfig<TData = Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassGetAdminClassFilterConfig<TData = Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassGetAdminClassFilterConfigQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassUpdateClassForOrganization = (
    organizationId: number,
    id: number,
    upsertAdminClassDTO: UpsertAdminClassDTO,
 ) => {
      
      
      return customInstance<AdminClassDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassDTO
    },
      );
    }
  


export const getAdminClassUpdateClassForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminClassDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminClassDTO}, TContext> => {
    
const mutationKey = ['adminClassUpdateClassForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>, {organizationId: number;id: number;data: UpsertAdminClassDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminClassUpdateClassForOrganization(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassUpdateClassForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>>
    export type AdminClassUpdateClassForOrganizationMutationBody = UpsertAdminClassDTO
    export type AdminClassUpdateClassForOrganizationMutationError = ErrorType<unknown>

    export const useAdminClassUpdateClassForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminClassDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassUpdateClassForOrganization>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminClassDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassUpdateClassForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassDeleteClassForOrganization = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminClassDeleteClassForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminClassDeleteClassForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminClassDeleteClassForOrganization(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassDeleteClassForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>>
    
    export type AdminClassDeleteClassForOrganizationMutationError = ErrorType<unknown>

    export const useAdminClassDeleteClassForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassDeleteClassForOrganization>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminClassDeleteClassForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassGetAdminClassEnrollments = (
    organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassEnrollmentsListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/roster/${classId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminClassGetAdminClassEnrollmentsQueryKey = (organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClass/roster/${classId}`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminClassGetAdminClassEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError = ErrorType<unknown>>(organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassGetAdminClassEnrollmentsQueryKey(organizationId,classId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>> = ({ signal }) => adminClassGetAdminClassEnrollments(organizationId,classId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && classId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassGetAdminClassEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>>
export type AdminClassGetAdminClassEnrollmentsQueryError = ErrorType<unknown>


export function useAdminClassGetAdminClassEnrollments<TData = Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number,
    params: undefined |  AdminClassGetAdminClassEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassEnrollments<TData = Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>,
          TError,
          Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassGetAdminClassEnrollments<TData = Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassGetAdminClassEnrollments<TData = Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number,
    params?: AdminClassGetAdminClassEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassGetAdminClassEnrollments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassGetAdminClassEnrollmentsQueryOptions(organizationId,classId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassCreateAdminClassEnrollment = (
    organizationId: number,
    classId: number,
    upsertAdminClassEnrollmentDTO: UpsertAdminClassEnrollmentDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminClassEnrollmentsListItemDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/roster/${classId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassEnrollmentDTO, signal
    },
      );
    }
  


export const getAdminClassCreateAdminClassEnrollmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>, TError,{organizationId: number;classId: number;data: UpsertAdminClassEnrollmentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>, TError,{organizationId: number;classId: number;data: UpsertAdminClassEnrollmentDTO}, TContext> => {
    
const mutationKey = ['adminClassCreateAdminClassEnrollment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>, {organizationId: number;classId: number;data: UpsertAdminClassEnrollmentDTO}> = (props) => {
          const {organizationId,classId,data} = props ?? {};

          return  adminClassCreateAdminClassEnrollment(organizationId,classId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassCreateAdminClassEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>>
    export type AdminClassCreateAdminClassEnrollmentMutationBody = UpsertAdminClassEnrollmentDTO
    export type AdminClassCreateAdminClassEnrollmentMutationError = ErrorType<unknown>

    export const useAdminClassCreateAdminClassEnrollment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>, TError,{organizationId: number;classId: number;data: UpsertAdminClassEnrollmentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassCreateAdminClassEnrollment>>,
        TError,
        {organizationId: number;classId: number;data: UpsertAdminClassEnrollmentDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassCreateAdminClassEnrollmentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassUpdateAdminClassEnrollment = (
    organizationId: number,
    id: number,
    upsertAdminClassEnrollmentDTO: UpsertAdminClassEnrollmentDTO,
 ) => {
      
      
      return customInstance<AdminClassEnrollmentsListItemDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/roster/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminClassEnrollmentDTO
    },
      );
    }
  


export const getAdminClassUpdateAdminClassEnrollmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>, TError,{organizationId: number;id: number;data: UpsertAdminClassEnrollmentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>, TError,{organizationId: number;id: number;data: UpsertAdminClassEnrollmentDTO}, TContext> => {
    
const mutationKey = ['adminClassUpdateAdminClassEnrollment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>, {organizationId: number;id: number;data: UpsertAdminClassEnrollmentDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminClassUpdateAdminClassEnrollment(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassUpdateAdminClassEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>>
    export type AdminClassUpdateAdminClassEnrollmentMutationBody = UpsertAdminClassEnrollmentDTO
    export type AdminClassUpdateAdminClassEnrollmentMutationError = ErrorType<unknown>

    export const useAdminClassUpdateAdminClassEnrollment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>, TError,{organizationId: number;id: number;data: UpsertAdminClassEnrollmentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassUpdateAdminClassEnrollment>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminClassEnrollmentDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassUpdateAdminClassEnrollmentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassDeleteAdminClassEnrollment = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/roster/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminClassDeleteAdminClassEnrollmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminClassDeleteAdminClassEnrollment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminClassDeleteAdminClassEnrollment(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassDeleteAdminClassEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>>
    
    export type AdminClassDeleteAdminClassEnrollmentMutationError = ErrorType<unknown>

    export const useAdminClassDeleteAdminClassEnrollment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassDeleteAdminClassEnrollment>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminClassDeleteAdminClassEnrollmentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminClassExportClassStudents = (
    organizationId: number,
    classId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/export/${classId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminClassExportClassStudentsQueryKey = (organizationId: number,
    classId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminClass/export/${classId}`] as const;
    }

    
export const getAdminClassExportClassStudentsQueryOptions = <TData = Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError = ErrorType<unknown>>(organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminClassExportClassStudentsQueryKey(organizationId,classId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminClassExportClassStudents>>> = ({ signal }) => adminClassExportClassStudents(organizationId,classId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && classId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminClassExportClassStudentsQueryResult = NonNullable<Awaited<ReturnType<typeof adminClassExportClassStudents>>>
export type AdminClassExportClassStudentsQueryError = ErrorType<unknown>


export function useAdminClassExportClassStudents<TData = Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassExportClassStudents>>,
          TError,
          Awaited<ReturnType<typeof adminClassExportClassStudents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassExportClassStudents<TData = Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClassExportClassStudents>>,
          TError,
          Awaited<ReturnType<typeof adminClassExportClassStudents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminClassExportClassStudents<TData = Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminClassExportClassStudents<TData = Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError = ErrorType<unknown>>(
 organizationId: number,
    classId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminClassExportClassStudents>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminClassExportClassStudentsQueryOptions(organizationId,classId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminClassBulkCopyClasses = (
    organizationId: number,
    bulkCopyClassesDTO: BulkCopyClassesDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BulkCopyClassesResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminClass/bulk-copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkCopyClassesDTO, signal
    },
      );
    }
  


export const getAdminClassBulkCopyClassesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassBulkCopyClasses>>, TError,{organizationId: number;data: BulkCopyClassesDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminClassBulkCopyClasses>>, TError,{organizationId: number;data: BulkCopyClassesDTO}, TContext> => {
    
const mutationKey = ['adminClassBulkCopyClasses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminClassBulkCopyClasses>>, {organizationId: number;data: BulkCopyClassesDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminClassBulkCopyClasses(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminClassBulkCopyClassesMutationResult = NonNullable<Awaited<ReturnType<typeof adminClassBulkCopyClasses>>>
    export type AdminClassBulkCopyClassesMutationBody = BulkCopyClassesDTO
    export type AdminClassBulkCopyClassesMutationError = ErrorType<unknown>

    export const useAdminClassBulkCopyClasses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminClassBulkCopyClasses>>, TError,{organizationId: number;data: BulkCopyClassesDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminClassBulkCopyClasses>>,
        TError,
        {organizationId: number;data: BulkCopyClassesDTO},
        TContext
      > => {

      const mutationOptions = getAdminClassBulkCopyClassesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    